/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create strong random passwords`)
};

const es_pw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea contraseñas aleatorias y fuertes`)
};

const de_pw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie starke Zufallspasswörter`)
};

const nl_pw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creëer sterke willekeurige wachtwoorden`)
};

const fr_pw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer des mots de passe aléatoires forts`)
};

const it_pw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea password casuali forti`)
};

const pt_br2_pw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie senhas aleatórias fortes`)
};

const pt_pw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar senhas aleatórias fortes`)
};

const ja_pw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`強力なランダムパスワードを生成`)
};

const zh_pw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建强随机密码`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_nav_main_desc", locale)
	if (locale === "en") return en_pw_nav_main_desc(inputs)
	if (locale === "es") return es_pw_nav_main_desc(inputs)
	if (locale === "de") return de_pw_nav_main_desc(inputs)
	if (locale === "nl") return nl_pw_nav_main_desc(inputs)
	if (locale === "fr") return fr_pw_nav_main_desc(inputs)
	if (locale === "it") return it_pw_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_pw_nav_main_desc(inputs)
	if (locale === "pt") return pt_pw_nav_main_desc(inputs)
	if (locale === "ja") return ja_pw_nav_main_desc(inputs)
	return zh_pw_nav_main_desc(inputs)
};